import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDifyAssistant } from "services/difyService";

const Assistant = () => {
  const { id } = useParams();
  const [assistant, setAssistant] = useState();
  const [type, setType] = useState("");
  const types = ["chatbot", "workflow"];

  useEffect(() => {
    getAssistant();
  }, []);

  const getAssistant = async () => {
    var s = await getDifyAssistant(id);
    if (
      s.mode == "agent-chat" ||
      s.mode == "chat" ||
      s.mode == "advanced-chat"
    ) {
      setType("chat");
    }
    if (s.mode == "workflow") {
      setType("workflow");
    }
    setAssistant(s);
  };

  return (
    <>
      {/* <div
        style={{
          display: "flex",
          gap: "0.5rem",
          cursor: "pointer",
          alignItems: "center",
        }}
      >
        <IoIosArrowBack style={{ fontSize: "24px" }} />
        <div style={{ fontSize: "24px" }}>Assistants</div>
      </div> */}

      {assistant != null && (
        <iframe
          src={
            "https://dify.dgtlassist.app/" + type + "/" + assistant?.site?.code
          }
          style={{
            width: "100%",
            height: "100%",
            minHeight: "700px",
          }}
          allow="microphone"
        />
      )}
    </>
  );
};
export default Assistant;
